var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        border: '1px solid #edebe9',
        borderRadius: '4px',
        overflow: 'hidden',
        fontFamily: '"Segoe UI", "Segoe UI Web (West European)", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        fontSize: '14px',
        color: '#323130',
        position: 'relative',
    },
    viewContainer: {
        flex: 1,
        overflow: 'auto',
    },
    // Legacy proportions: main month col-md-9, stacked side months col-md-3.
    monthlyLayout: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
    },
    monthlyMain: {
        flex: '1 1 75%',
        minWidth: 0,
    },
    monthlySide: {
        flex: '0 0 25%',
        minWidth: '180px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        paddingRight: '8px',
    },
};
export default styles;
//# sourceMappingURL=YearlyCalendar.styles.js.map